<script lang="ts" setup>
import { toRefs } from 'vue';

interface DisciplineIconInterface {
  code: string;
  name: string;
}

interface Props {
  icon?: DisciplineIconInterface;
  className?: string;
}

const props = defineProps<Props>();
const { icon, className } = toRefs(props);
</script>

<template>
  <div :class="className">
    <Icon :name="icon?.name || 'category'" size="text-base" class="mr-1 text-color-purple" />
    <span class="text-sm" v-text="icon?.code" />
  </div>
</template>
